/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_LabelInputs */

const en_svc_research_label = /** @type {(inputs: Svc_Research_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI research agents`)
};

const lv_svc_research_label = /** @type {(inputs: Svc_Research_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI izpētes aģenti`)
};

/**
* | output |
* | --- |
* | "AI research agents" |
*
* @param {Svc_Research_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_label = /** @type {((inputs?: Svc_Research_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_label(inputs)
	return en_svc_research_label(inputs)
});